// DeliveryUp.tsx
import React, { useState, useRef } from 'react'; // ✅ include useRef
import * as XLSX from 'xlsx';
import axios from 'axios';
import Swal from 'sweetalert2';

const DeliveryUp = () => {
  const [excelData, setExcelData] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const fileInputRef = useRef<HTMLInputElement | null>(null);


  const MAX_CALLS = 10;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target?.result as string;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      const formattedData = rawData.map((row: any) => {
        let formattedDate = row.DelvDt;
        let formattedTime = row.Delv_Time;

        if (typeof row.DelvDt === 'number') {
          const date = XLSX.SSF.parse_date_code(row.DelvDt);
          if (date) {
            const day = String(date.d).padStart(2, '0');
            const month = String(date.m).padStart(2, '0');
            const year = date.y;
            formattedDate = `${day}/${month}/${year}`;
          }
        }

        if (typeof row.Delv_Time === 'number') {
          const totalSeconds = Math.round(row.Delv_Time * 24 * 60 * 60);
          const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
          const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
          formattedTime = `${hours}:${minutes}`;
        }

        return {
          ...row,
          DelvDt: formattedDate,
          Delv_Time: formattedTime,
        };
      });

      setExcelData(formattedData);
      setProgress(0);

      // Optional: Save to localStorage for access from other pages
      localStorage.setItem('deliveryData', JSON.stringify(formattedData));
    };

    reader.readAsBinaryString(file);
  };

  const handleUpload = async () => {
    if (excelData.length === 0) {
      Swal.fire('No Data', 'Please select an Excel file first.', 'warning');
      return;
    }

    setUploading(true);
    setProgress(0);
    const chunkSize = Math.ceil(excelData.length / MAX_CALLS);
    let successCount = 0;

    for (let i = 0; i < MAX_CALLS; i++) {
      const chunk = excelData.slice(i * chunkSize, (i + 1) * chunkSize);
      if (chunk.length === 0) continue;

      try {
        const res = await axios.post('http://localhost:2600/DeliveryUp', {
          excelData: chunk,
        });

        if (res.data.status === 1) {
          successCount += chunk.length;
        }
      } catch (err) {
        console.error(`Chunk ${i + 1} failed`, err);
      }

      setProgress(Math.round(((i + 1) / MAX_CALLS) * 100));
    }

    setUploading(false);

    if (successCount > 0) {
      Swal.fire('Upload Complete', `✅ ${successCount} of ${excelData.length} rows uploaded.`, 'success');
      setExcelData([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } else {
      Swal.fire('Upload Failed', '❌ All rows failed to upload.', 'error');
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '500px', margin: 'auto' }}>
      <h3>📤 Delivery Status Upload</h3>

      <input
        ref={fileInputRef} // ✅ add this line to bind the ref
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileChange}
        className="form-control mb-3"
      />

      <button
        onClick={handleUpload}
        disabled={uploading || excelData.length === 0}
        className="btn btn-primary mb-3"
      >
        {uploading ? 'Uploading...' : 'Start Upload'}
      </button>

      {uploading && (
        <div>
          <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '20px' }}>
            <div
              style={{
                width: `${progress}%`,
                backgroundColor: '#4caf50',
                height: '100%',
                borderRadius: '4px',
                transition: 'width 0.5s ease-in-out',
              }}
            />
          </div>
          <p className="text-center mt-2">{progress}% completed</p>
        </div>
      )}
    </div>
  );
};

export default DeliveryUp;
